import QuestionSubjectsForm from './QuestionSubjectsForm.component';

export default QuestionSubjectsForm;
